/* Yake (Pebble) slideshow → Concept portu. Bağımsız vanilla JS, global bağımlılık yok.
   Çapraz solma (fade), döngü, otomatik oynatma, sayaç + ilerleme çizgisi, ok çifti,
   mobilde kaydırma, tema editörü olayları. */
(function () {
  'use strict';

  var INSTANCES = [];

  function YkSlideshow(root) {
    this.root = root;
    this.track = root.querySelector('[data-ykslide-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-ykslide-slide]'));
    this.counter = root.querySelector('[data-ykslide-counter]');
    this.progress = root.querySelector('[data-ykslide-progress]');
    this.prevBtn = root.querySelector('[data-ykslide-prev]');
    this.nextBtn = root.querySelector('[data-ykslide-next]');
    this.index = 0;
    this.timer = null;
    this.paused = false;
    this.inView = true;
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && this.slides.length > 1;
    this.delay = parseInt(root.getAttribute('data-autoplay-delay'), 10) || 5000;

    this._bind();
    this._update();
    this._startAutoplay();
  }

  YkSlideshow.prototype._bind = function () {
    var self = this;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.goTo(self.index - 1);
        self._restartAutoplay();
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.goTo(self.index + 1);
        self._restartAutoplay();
      });
    }

    // Fareyle üzerine gelince duraklat (kaynaktaki swiper davranışına yakın)
    this.root.addEventListener('mouseenter', function () {
      self.paused = true;
      self._stopAutoplay();
    });
    this.root.addEventListener('mouseleave', function () {
      self.paused = false;
      self._startAutoplay();
    });

    // Dokunmatik kaydırma (yatay, 40px eşik)
    var startX = null;
    var startY = null;
    this.track.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    this.track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      startX = null;
      startY = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      self.goTo(self.index + (dx < 0 ? 1 : -1));
      self._restartAutoplay();
    }, { passive: true });

    // Klavye: sol/sağ ok
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        self.goTo(self.index - 1);
        self._restartAutoplay();
      } else if (e.key === 'ArrowRight') {
        self.goTo(self.index + 1);
        self._restartAutoplay();
      }
    });

    // Görünürde değilken oynatma
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(function (entries) {
        self.inView = entries[0].isIntersecting;
        if (self.inView) {
          self._startAutoplay();
        } else {
          self._stopAutoplay();
        }
      }, { threshold: 0.1 });
      this.observer.observe(this.root);
    }

    this._onVisibility = function () {
      if (document.hidden) {
        self._stopAutoplay();
      } else {
        self._startAutoplay();
      }
    };
    document.addEventListener('visibilitychange', this._onVisibility);
  };

  YkSlideshow.prototype.goTo = function (i) {
    var n = this.slides.length;
    if (n < 2) return;
    this.index = ((i % n) + n) % n;

    for (var s = 0; s < n; s++) {
      var slide = this.slides[s];
      var active = s === this.index;
      slide.classList.toggle('is-active', active);
      if (active) {
        slide.removeAttribute('aria-hidden');
        slide.removeAttribute('inert');
      } else {
        slide.setAttribute('aria-hidden', 'true');
        slide.setAttribute('inert', '');
      }
    }
    this._update();
  };

  YkSlideshow.prototype._update = function () {
    var n = this.slides.length;
    if (this.counter) {
      this.counter.textContent = (this.index + 1) + ' / ' + n;
    }
    if (this.progress) {
      this.progress.style.transform = 'scaleX(' + ((this.index + 1) / n) + ')';
    }
    // Pasif slaytlardaki odaklanabilir öğeleri kapat (ilk yüklemede de)
    for (var s = 0; s < n; s++) {
      if (s !== this.index) {
        this.slides[s].setAttribute('inert', '');
      }
    }
  };

  YkSlideshow.prototype._startAutoplay = function () {
    var self = this;
    if (!this.autoplay || this.paused || !this.inView || this.timer) return;
    this.timer = setInterval(function () {
      self.goTo(self.index + 1);
    }, this.delay);
  };

  YkSlideshow.prototype._stopAutoplay = function () {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  YkSlideshow.prototype._restartAutoplay = function () {
    this._stopAutoplay();
    this._startAutoplay();
  };

  YkSlideshow.prototype.destroy = function () {
    this._stopAutoplay();
    if (this.observer) this.observer.disconnect();
    document.removeEventListener('visibilitychange', this._onVisibility);
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-ykslide]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.__ykslide) return;
      root.__ykslide = new YkSlideshow(root);
      INSTANCES.push(root.__ykslide);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Tema editörü
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-ykslide]');
    if (root && root.__ykslide) {
      root.__ykslide.destroy();
      root.__ykslide = null;
    }
  });

  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest ? (e.target.matches('[data-ykslide-slide]') ? e.target : e.target.closest('[data-ykslide-slide]')) : null;
    if (!slide) return;
    var root = slide.closest('[data-ykslide]');
    if (!root || !root.__ykslide) return;
    var inst = root.__ykslide;
    inst.paused = true;
    inst._stopAutoplay();
    inst.goTo(inst.slides.indexOf(slide));
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var slide = e.target.closest ? e.target.closest('[data-ykslide]') : null;
    if (slide && slide.__ykslide) {
      slide.__ykslide.paused = false;
      slide.__ykslide._startAutoplay();
    }
  });
})();
